<div [formGroup]="triggerQueryNotificationForm">
  <div class="row">
    <div class="col-12 col-lg-6">
      <!--SUBJECT-->
      <div class="form-group">
        <label for="subject" translate>Subject</label>
        <scitis-required-field-indicator></scitis-required-field-indicator>
        <input (focusout)="onFocusOut()" [ngClass]="{ 'is-invalid': formControls.subject.errors }"
          class="form-control" formControlName="subject" id="subject" name="subject" type="text">
          @if (formControls.subject.errors) {
            <div class="invalid-feedback">
              @if (formControls.subject.errors.required) {
                <span translate>Email subject required</span>
              }
            </div>
          }
        </div>

        <!--EMAIL MESSAGE-->
        <div class="form-group">
          <label for="message" translate>E-mail message</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <textarea (focusout)="onFocusOut()" [ngClass]="{ 'is-invalid': formControls.message.errors }"
            class="form-control" formControlName="message" id="message" name="message" rows="10">
          </textarea>
          @if (formControls.message.errors) {
            <div class="invalid-feedback">
              @if (formControls.message.errors.required) {
                <span translate>Trigger action mail message required</span>
              }
            </div>
          }
        </div>

      </div>

      <div class="col-12 col-lg-6">

        <!--ADD SUBSCRIPTION-->
        @if (isDistributorOrHigher && userNames.length > 0) {
          <div class="form-group">
            <label for="newSubscriber" translate>Add subscription</label>
            <scitis-required-field-indicator></scitis-required-field-indicator>
            @if (isLoadingSubscribers) {
              <span class="fa-solid fa-spinner fa-spin"></span>
            }
            @if (userNames.length > 0) {
              <ng-select (change)="onNewSubscriberChange($event)" (focusout)="onFocusOut()"
                [items]="userNames" [ngClass]="{ 'is-invalid': formControls.subscriberList.errors }"
                bindLabel="name" bindValue="id" formControlName="newSubscriber" id="newSubscriber"
                placeholder="Select subscriber">
              </ng-select>
            }
            <input [hidden]="true" [ngClass]="{ 'is-invalid': formControls.subscriberList.errors }"
              class="form-control"
              id="selectedNewSubscriber" type="text">
              @if (formControls.subscriberList.errors) {
                <div class="invalid-feedback">
                  <span translate>Email required</span>
                </div>
              }
            </div>
          }

          <!-- Fallback for admins -->
          @if (superOrTechAdminRole && subscriberList.length === 0) {
            <div class="alert alert-info" translate>
              Currently no subscribers are selected, please add subscribers above.
            </div>
          }

          <!-- Fallback for users -->
          @if (!isDistributorOrHigher && !usernameSubscribed) {
            <div class="alert alert-info">
              <p translate>Currently You are not subscribed to this trigger action.</p>
              <button (click)="subscribeLoggedUser()"
                class="btn btn-outline-info btn-block"
                type="button"><span translate>Subscribe</span></button>
              </div>
            }

            @if (subscriberList.length > 0) {
              <div>
                <h5 class="h6" translate>Subscribers</h5>
                <div class="scrollarea" style="max-height: 392px;">
                  <ul class="list-group">
                    @for (subscriber of subscriberList; track subscriber) {
                      <li class="list-group-item">
                        <div class="row align-items-center">
                          <div class="col" style="max-width: calc(100% - 56px)">
                            <span class="text-truncate d-block" [title]="subscriber">
                              <span [innerText]="subscriber"></span>
                            </span>
                          </div>
                          <div class="col-auto">
                            @if (showRemoveSubscriptionButton(subscriber)) {
                              <button (click)="onRemoveSubscriber(subscriber)" class="btn btn-outline-danger btn-xs"
                                title="{{'Remove subscription' | translate}}"><span class="fa-solid fa-trash"></span>
                              </button>
                            }
                          </div>
                        </div>
                      </li>
                    }
                  </ul>
                </div>
              </div>
            }
          </div>
        </div>
      </div>